import React from "react";
interface IDsBadgeProps{
    notificationStatus:string,
    isSmall?:boolean
    backgroundColor?:string
}
const DsBadge:React.FC<IDsBadgeProps>=(props):JSX.Element=>{
    const {notificationStatus, isSmall} = props;
    return (
        <ds-notification-badge
            notification-status={notificationStatus}
            badge-variant="default"
            badge-number="0"
            badge-aria-label="Badge aria label"
            is-small={isSmall ? "true" : "false"}
            background-color={notificationStatus==="custom" ? props.backgroundColor : ""}
        ></ds-notification-badge>
    )
}
export default DsBadge;